module.exports = __webpack_public_path__ + "img/s_marker.2be77e71.svg";